import { GMSizedIcon } from '../../Icon';
import { BaseCheckbox } from '../BaseCheckbox/BaseCheckbox';
import css from './Checkbox.module.scss';
import { CheckboxProps } from './Checkbox.types';

/**
 * The `Checkbox` control. This is either used as is when just a checkbox without a label is needed,
 * or wrapped by the `FormCheckbox` control to handle labels.
 *
 * @param title - {@link CheckboxProps.title title} description.
 * @param checked - {@link CheckboxProps.checked checked} description. (default: false)
 * @param disabled - {@link CheckboxProps.disabled disabled} description. (default: false)
 * @param onChange - {@link CheckboxProps.onChange onChange} description.
 * @param iconSize - {@link CheckboxProps.iconSize iconSize} description. (default: 'medium')
 */
const Checkbox = ({
    title,
    checked = false,
    disabled = false,
    onChange,
    iconSize = 'medium',
}: CheckboxProps) => {
    return (
        <BaseCheckbox
            title={title}
            classes={{
                root: css.checkbox,
                checked: css.checked,
                disabled: css.disabled,
            }}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            icon={
                <GMSizedIcon
                    title={'Unchecked Checkbox'}
                    iconType={'Checkbox'}
                    iconSize={iconSize}
                />
            }
            checkedIcon={
                <GMSizedIcon
                    title={'Checked Checkbox'}
                    iconType={'Checkbox-Selected'}
                    iconSize={iconSize}
                />
            }
        />
    );
};

export default Checkbox;